import CustomEvent from "custom-event";

function publishEvent(type, value) {
  const event = new CustomEvent(type, value);
  window.dispatchEvent(event);
}

export function publishConsentManagerInitialized() {
  publishEvent("consentManagerInitialized", {});
}

export function publishConsentProvided(categories) {
  publishEvent("cookieConsentProvided", {
    detail: {
      categories,
    },
  });
}
